var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { api_service } from '../../api/api_service';
import { api_urls } from '../../api/api_urls';
var SOURCE_DOCUMENT_TYPE_ALIASES = {
    DocumentPackage: ['document package'],
    DriverLicense: ['drivers license', "driver's license", 'driver license'],
    DealerInvoice: ['invoices/sales order', 'invoice/sales order', 'invoice'],
};
var entryTypeIs = function (entry) {
    var names = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        names[_i - 1] = arguments[_i];
    }
    return names.some(function (name) { return String(entry.DocumentType).toLowerCase() === name.toLowerCase(); });
};
var entriesToResult = function (entries) { return ({
    documentPackage: entries.find(function (e) { return entryTypeIs(e, 'DocumentPackage', 'DocPkg'); }),
    driverLicense: entries.find(function (e) { return entryTypeIs(e, 'DriverLicense', 'DL'); }),
    dealerInvoice: entries.find(function (e) { return entryTypeIs(e, 'DealerInvoice', 'Invoice'); }),
    validation: entries.find(function (e) { return entryTypeIs(e, 'Validation'); }),
}); };
var lastRunStorageKey = function (TxAspireOId) { return "postDocsAiLastRun:".concat(TxAspireOId); };
var resolveLastRunAt = function (TxAspireOId, ranFresh) {
    var now = new Date().toISOString();
    try {
        var stored = window.localStorage.getItem(lastRunStorageKey(TxAspireOId));
        if (!ranFresh && stored)
            return stored;
        window.localStorage.setItem(lastRunStorageKey(TxAspireOId), now);
    }
    catch (_a) {
    }
    return now;
};
var findLatestByAliases = function (documents, aliases) {
    return documents
        .filter(function (doc) {
        var type = (doc.DocumentType || '').toLowerCase();
        return aliases.some(function (alias) { return type.includes(alias); });
    })
        .sort(function (a, b) { return new Date(b.CreatedDate).getTime() - new Date(a.CreatedDate).getTime(); })[0];
};
var DOWNLOAD_TIMEOUT_MS = 5 * 60 * 1000;
export var findSourceDocuments = function (documents) { return ({
    documentPackage: findLatestByAliases(documents, SOURCE_DOCUMENT_TYPE_ALIASES.DocumentPackage),
    dealerInvoice: findLatestByAliases(documents, SOURCE_DOCUMENT_TYPE_ALIASES.DealerInvoice),
    driverLicense: findLatestByAliases(documents, SOURCE_DOCUMENT_TYPE_ALIASES.DriverLicense),
}); };
var fetchDocumentAsFile = function (TxAspireOId, doc) { return __awaiter(void 0, void 0, void 0, function () {
    var response, contentType;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4, api_service.get({
                    endPoint: api_urls.GET_APP_DOCUMENTS,
                    payLoad: {
                        TxAspireOId: TxAspireOId,
                        DocumentIdentifier: doc.DocumentIdentifier,
                    },
                    showLoader: false,
                    responseType: 'arraybuffer',
                    timeout: DOWNLOAD_TIMEOUT_MS,
                })];
            case 1:
                response = _b.sent();
                contentType = String(((_a = response === null || response === void 0 ? void 0 : response.headers) === null || _a === void 0 ? void 0 : _a['content-type']) || 'application/octet-stream');
                return [2, new File([response.data], doc.FileName || doc.DocumentIdentifier, { type: contentType })];
        }
    });
}); };
var NOTHING_CACHED = { documentPackage: false, driverLicense: false, dealerInvoice: false };
var fetchDocumentCacheStatus = function (TxAspireOId, documentPackageDoc, driverLicenseDoc, dealerInvoiceDoc) { return __awaiter(void 0, void 0, void 0, function () {
    var res, data, _a;
    var _b, _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                if (!documentPackageDoc.DocumentStorageOId)
                    return [2, NOTHING_CACHED];
                _d.label = 1;
            case 1:
                _d.trys.push([1, 3, , 4]);
                return [4, api_service.get({
                        endPoint: api_urls.DOCUMENTS_CACHE_STATUS,
                        payLoad: __assign(__assign({ TxAspireOId: TxAspireOId, DocumentPackageStorageOId: documentPackageDoc.DocumentStorageOId }, ((driverLicenseDoc === null || driverLicenseDoc === void 0 ? void 0 : driverLicenseDoc.DocumentStorageOId) ? { DriverLicenseStorageOId: driverLicenseDoc.DocumentStorageOId } : {})), ((dealerInvoiceDoc === null || dealerInvoiceDoc === void 0 ? void 0 : dealerInvoiceDoc.DocumentStorageOId) ? { DealerInvoiceStorageOId: dealerInvoiceDoc.DocumentStorageOId } : {})),
                        showLoader: false,
                    })];
            case 2:
                res = _d.sent();
                data = (_b = res === null || res === void 0 ? void 0 : res.data) === null || _b === void 0 ? void 0 : _b.data;
                if (((_c = res === null || res === void 0 ? void 0 : res.data) === null || _c === void 0 ? void 0 : _c.statusCode) !== 200 || !data)
                    return [2, NOTHING_CACHED];
                return [2, {
                        documentPackage: data.DocumentPackageCached === true,
                        driverLicense: data.DriverLicenseCached === true,
                        dealerInvoice: data.DealerInvoiceCached === true,
                    }];
            case 3:
                _a = _d.sent();
                return [2, NOTHING_CACHED];
            case 4: return [2];
        }
    });
}); };
export var extractApplicationDocuments = function (TxAspireOId, documents, _a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.rerun, rerun = _c === void 0 ? false : _c;
    return __awaiter(void 0, void 0, void 0, function () {
        var documentPackageDoc, driverLicenseDoc, dealerInvoiceDoc, cached, _d, _e, documentPackageFile, dealerInvoiceFile, driverLicenseFile, formData, response, entries, result;
        var _f, _g, _h;
        return __generator(this, function (_j) {
            switch (_j.label) {
                case 0:
                    documentPackageDoc = findLatestByAliases(documents, SOURCE_DOCUMENT_TYPE_ALIASES.DocumentPackage);
                    driverLicenseDoc = findLatestByAliases(documents, SOURCE_DOCUMENT_TYPE_ALIASES.DriverLicense);
                    dealerInvoiceDoc = findLatestByAliases(documents, SOURCE_DOCUMENT_TYPE_ALIASES.DealerInvoice);
                    if (!documentPackageDoc) {
                        return [2, null];
                    }
                    if (!rerun) return [3, 1];
                    _d = NOTHING_CACHED;
                    return [3, 3];
                case 1: return [4, fetchDocumentCacheStatus(TxAspireOId, documentPackageDoc, driverLicenseDoc, dealerInvoiceDoc)];
                case 2:
                    _d = _j.sent();
                    _j.label = 3;
                case 3:
                    cached = _d;
                    return [4, Promise.all([
                            cached.documentPackage ? Promise.resolve(undefined) : fetchDocumentAsFile(TxAspireOId, documentPackageDoc),
                            dealerInvoiceDoc && !cached.dealerInvoice ? fetchDocumentAsFile(TxAspireOId, dealerInvoiceDoc) : Promise.resolve(undefined),
                            driverLicenseDoc && !cached.driverLicense ? fetchDocumentAsFile(TxAspireOId, driverLicenseDoc) : Promise.resolve(undefined),
                        ])];
                case 4:
                    _e = _j.sent(), documentPackageFile = _e[0], dealerInvoiceFile = _e[1], driverLicenseFile = _e[2];
                    formData = new FormData();
                    formData.append('TxAspireOId', TxAspireOId);
                    if (documentPackageDoc.DocumentStorageOId)
                        formData.append('DocumentPackageStorageOId', documentPackageDoc.DocumentStorageOId);
                    if (driverLicenseDoc === null || driverLicenseDoc === void 0 ? void 0 : driverLicenseDoc.DocumentStorageOId)
                        formData.append('DriverLicenseStorageOId', driverLicenseDoc.DocumentStorageOId);
                    if (dealerInvoiceDoc === null || dealerInvoiceDoc === void 0 ? void 0 : dealerInvoiceDoc.DocumentStorageOId)
                        formData.append('DealerInvoiceStorageOId', dealerInvoiceDoc.DocumentStorageOId);
                    formData.append('RerunRequired', rerun ? '1' : '0');
                    if (documentPackageFile)
                        formData.append('DocumentPackage', documentPackageFile);
                    if (dealerInvoiceFile)
                        formData.append('DealerInvoice', dealerInvoiceFile);
                    if (driverLicenseFile)
                        formData.append('DriverLicense', driverLicenseFile);
                    return [4, api_service.post({
                            endPoint: api_urls.EXTRACT_APPLICATION_DOCUMENTS,
                            payLoad: formData,
                            headerType: api_service.ContentHeaders.FormData,
                            showLoader: false,
                            timeout: DOWNLOAD_TIMEOUT_MS,
                        })];
                case 5:
                    response = _j.sent();
                    if (((_f = response === null || response === void 0 ? void 0 : response.data) === null || _f === void 0 ? void 0 : _f.statusCode) !== 200 || !Array.isArray((_g = response === null || response === void 0 ? void 0 : response.data) === null || _g === void 0 ? void 0 : _g.data)) {
                        throw new Error(((_h = response === null || response === void 0 ? void 0 : response.data) === null || _h === void 0 ? void 0 : _h.message) || 'extract-documents returned an unexpected response');
                    }
                    entries = response.data.data;
                    result = entriesToResult(entries);
                    result.reviewedAt = resolveLastRunAt(TxAspireOId, rerun || Boolean(documentPackageFile || dealerInvoiceFile || driverLicenseFile));
                    return [2, result];
            }
        });
    });
};
